export interface Data {}
export interface Computed {
  labelClass: {
    "event__label--ownOrganization": boolean;
    "event__label--thisYear": boolean;
    "event__label--oneYearAgo": boolean;
    "event__label--twoYearAgo": boolean;
  };
  selectedClass: {
    "event__label--ownOrganization--isSelected": boolean;
    "event__label--thisYear--isSelected": boolean;
    "event__label--oneYearAgo--isSelected": boolean;
    "event__label--twoYearAgo--isSelected": boolean;
  };
}

export enum EventTypes {
  OwnOrganization = "ownOrganization",
  ThisYearEvent = "thisYearEvent",
  OneYearAgoEvent = "oneYearAgoEvent",
  TwoYearAgoEvent = "twoYearAgoEvent"
}
export interface Props {
  eventType: EventTypes;
  name: string;
  isSelected: boolean;
}

export interface Methods {
  handleClick: () => void;
  handleKeydown: (event: KeyboardEvent) => void;
}
